export const translations = {
  header: {
    title: { he: 'חשמל עכשיו', en: 'Electricity Now' },
    subtitle: { he: 'תעריף חשמל בזמן אמת', en: 'Real-Time Electricity Rate' },
    transitionNote: { he: 'עונת מעבר — בקיץ ובחורף הפער גדול בהרבה!', en: 'Transition season — the gap is much bigger in summer & winter!' },
  },

  rate: {
    expensive: { he: 'עכשיו החשמל יקר!', en: 'Electricity is expensive now!' },
    cheap: { he: 'עכשיו החשמל זול!', en: 'Electricity is cheap now!' },
    perKwh: { he: '₪ לקוט״ש', en: '₪/kWh' },
    season: { he: 'עונה:', en: 'Season:' },
    live: { he: 'LIVE', en: 'LIVE' },
  },

  seasons: {
    winter: { he: 'חורף', en: 'Winter' },
    transition: { he: 'מעבר', en: 'Transition' },
    summer: { he: 'קיץ', en: 'Summer' },
  },

  countdown: {
    electricityWillBe: { he: 'החשמל יהיה', en: 'Electricity will be' },
    expensive: { he: 'יקר', en: 'expensive' },
    cheap: { he: 'זול', en: 'cheap' },
    in: { he: 'עוד', en: 'in' },
    hours: { he: 'שעות', en: 'hours' },
    minutes: { he: 'דקות', en: 'minutes' },
    seconds: { he: 'שניות', en: 'seconds' },
    expensiveIn: { he: 'תעריף יקר בעוד', en: 'Expensive rate in' },
    cheapIn: { he: 'תעריף זול בעוד', en: 'Cheap rate in' },
  },

  timeline: {
    title: { he: 'לוח זמנים יומי', en: 'Daily Schedule' },
    peak: { he: 'פסגה', en: 'Peak' },
    offpeak: { he: 'שפל', en: 'Off-Peak' },
    peakShort: { he: 'פסגה', en: 'Peak' },
    offpeakShort: { he: 'שפל', en: 'Off-Peak' },
    popoverRate: { he: '₪/קוט״ש', en: '₪/kWh' },
    multiplier: {
      he: (x: string) => `פסגה יקרה פי ${x}`,
      en: (x: string) => `Peak costs ×${x} more`,
    },
  },

  calculator: {
    title: { he: 'מחשבון עלות מכשירים', en: 'Appliance Cost Calculator' },
    titleShort: { he: 'מחשבון עלות', en: 'Cost Calculator' },
    preview: { he: 'בחרו מכשיר לחישוב עלות', en: 'Select an appliance to calculate cost' },
    costNow: { he: 'עלות עכשיו/שעה', en: 'Cost now/hour' },
    costOffpeak: { he: 'עלות בשפל/שעה', en: 'Off-peak cost/hour' },
    costPeak: { he: 'עלות בפסגה/שעה', en: 'Peak cost/hour' },
    runNow: { he: 'הפעילו עכשיו וחסכו!', en: 'Run now and save!' },
    waitAndSave: { he: 'המתינו לשפל וחסכו!', en: 'Wait for off-peak and save!' },
    saving: { he: 'חיסכון:', en: 'Savings:' },
    perHour: { he: '₪ לשעה', en: '₪/hour' },
    yearlySaving: { he: 'חיסכון שנתי משוער:', en: 'Est. yearly saving:' },
    perYear: { he: '₪ בשנה', en: '₪/year' },
    transitionNote: { he: 'בקיץ ובחורף החיסכון גדול פי 3!', en: 'In summer & winter, savings are up to ×3 bigger!' },
  },

  appliances: {
    ac: { he: 'מזגן', en: 'AC' },
    dryer: { he: 'מייבש כביסה', en: 'Clothes Dryer' },
    washer: { he: 'מכונת כביסה', en: 'Washing Machine' },
    dishwasher: { he: 'מדיח כלים', en: 'Dishwasher' },
    oven: { he: 'תנור', en: 'Oven' },
    fridge: { he: 'מקרר', en: 'Refrigerator' },
    tv: { he: 'טלוויזיה', en: 'TV' },
    computer: { he: 'מחשב', en: 'Computer' },
    ev: { he: 'טעינת רכב חשמלי', en: 'EV Charging' },
  },

  shabbat: {
    title: { he: 'שבת וחגים', en: 'Shabbat & Holidays' },
    titleShort: { he: 'שבת וחגים', en: 'Shabbat & Holidays' },
    shabbatCheap: { he: 'שבת = חשמל זול!', en: 'Shabbat = cheap electricity!' },
    candleLighting: { he: 'כניסת שבת:', en: 'Shabbat entrance:' },
    upcomingHolidays: { he: 'חגים קרובים (תעריף שפל):', en: 'Upcoming holidays (off-peak rate):' },
    noInfo: { he: 'לא נמצא מידע על שבת וחגים', en: 'No Shabbat or holiday info available' },
  },

  tips: {
    title: { he: 'טיפים לחיסכון', en: 'Saving Tips' },
    titleShort: { he: 'טיפים לחיסכון', en: 'Saving Tips' },
    preview: {
      he: (amount: number) => `חסכו עד ${amount}₪ בחודש`,
      en: (amount: number) => `Save up to ${amount}₪/month`,
    },
    insight: {
      he: 'העבירו מכשירים כבדים לשעות השפל (לילות וסופ״ש) — התעריף נמוך משמעותית',
      en: 'Shift heavy appliances to off-peak hours (nights & weekends) — rates are significantly lower',
    },
    perMonth: { he: '₪/חודש', en: '₪/mo' },
  },

  quickAdvice: {
    runNow: {
      he: (appliance: string, saving: string) => `הפעילו ${appliance} עכשיו — חסכו ${saving}₪/שעה`,
      en: (appliance: string, saving: string) => `Run your ${appliance} NOW — save ${saving}₪/hr vs peak`,
    },
    waitFor: {
      he: (appliance: string, saving: string) => `המתינו לתעריף זול — ${appliance} יחסוך ${saving}₪/שעה`,
      en: (appliance: string, saving: string) => `Wait for cheap rates — ${appliance} saves ${saving}₪/hr`,
    },
    seeMore: { he: 'למחשבון המלא', en: 'Full calculator' },
  },

  donate: {
    prompt: { he: 'תרמו לכיסוי עלויות החשמל של האתר', en: 'Donate to cover this site\'s electricity costs' },
    liked: { he: 'אהבתם? תתמכו בפרויקט', en: 'Like it? Support the project' },
    bit: { he: '💙 Bit', en: '💙 Bit' },
    copied: { he: '✅ הועתק!', en: '✅ Copied!' },
    copiedMessage: {
      he: (phone: string) => `מספר ${phone} הועתק — פתחו ביט ושלחו`,
      en: (phone: string) => `Number ${phone} copied — open Bit and paste`,
    },
    cardPrompt: { he: 'בניתי את זה בשבילכם בחינם. אם חסכתם כסף, קנו לי קפה', en: 'Built this for you for free. If it saved you money, buy me a coffee' },
  },

  collapsible: {
    calculator: { he: 'מחשבון עלות', en: 'Cost Calculator' },
    tips: { he: 'טיפים לחיסכון', en: 'Saving Tips' },
    shabbat: { he: 'שבת וחגים', en: 'Shabbat & Holidays' },
  },

  footer: {
    about: {
      he: 'מחיר החשמל בישראל משתנה לפי שעות היום — בשעות עומס התעריף גבוה יותר. האתר הזה עוזר לכם לדעת בדיוק מתי כדאי להפעיל מכשירים ולחסוך בחשבון החשמל.',
      en: 'Electricity prices in Israel change throughout the day — during peak demand hours, rates are higher. This site helps you know exactly when to run appliances and save on your electricity bill.',
    },
    lastUpdate: { he: 'עדכון אחרון:', en: 'Last updated:' },
    disclaimer: { he: 'האתר אינו קשור לחברת החשמל ואינו מהווה ייעוץ', en: 'This site is not affiliated with IEC and does not constitute advice' },
    rateUpdateDate: { he: 'מרץ 2026', en: 'March 2026' },
  },

  share: {
    whatsapp: { he: 'שתפו בוואטסאפ', en: 'Share on WhatsApp' },
    shareExpensive: {
      he: (rate: string) => `🔴 עכשיו החשמל יקר! (${rate} ₪/קוט"ש)\nבדקו מתי לחסוך בחשמל:\nhttps://hashmal.live`,
      en: (rate: string) => `🔴 Electricity is expensive now! (${rate} ₪/kWh)\nCheck when to save on electricity:\nhttps://hashmal.live`,
    },
    shareCheap: {
      he: (rate: string) => `🟢 עכשיו החשמל זול! (${rate} ₪/קוט"ש)\nבדקו מתי לחסוך בחשמל:\nhttps://hashmal.live`,
      en: (rate: string) => `🟢 Electricity is cheap now! (${rate} ₪/kWh)\nCheck when to save on electricity:\nhttps://hashmal.live`,
    },
  },
} as const

// ── Type helpers ──────────────────────────────────────────────────────────────

type Translations = typeof translations

/** Recursively build dot-separated keys for all leaf { he, en } entries */
type TranslationKeys<T, Prefix extends string = ''> = {
  [K in keyof T]: T[K] extends { he: unknown; en: unknown }
    ? `${Prefix}${K & string}`
    : T[K] extends Record<string, unknown>
      ? TranslationKeys<T[K], `${Prefix}${K & string}.`>
      : never
}[keyof T]

export type TranslationKey = TranslationKeys<Translations>

/** Resolve a dot-separated key to its leaf value */
type Resolve<T, K extends string> =
  K extends `${infer Head}.${infer Rest}`
    ? Head extends keyof T
      ? Resolve<T[Head], Rest>
      : never
    : K extends keyof T
      ? T[K]
      : never

export type TranslationValue<K extends TranslationKey> = Resolve<Translations, K>

export type Language = 'he' | 'en'

/**
 * Look up a translation value by dot-separated key.
 * Returns the raw value — could be a string or a function for parameterised translations.
 */
export function getTranslation<K extends TranslationKey>(
  key: K,
  lang: Language,
): TranslationValue<K> extends { he: infer V } ? V : never {
  const parts = key.split('.')
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let node: any = translations
  for (const part of parts) {
    node = node[part]
    if (node === undefined) {
      throw new Error(`Translation key not found: ${key}`)
    }
  }
  return node[lang]
}
